import { render, staticRenderFns } from "./SubWarning.vue?vue&type=template&id=40ca515b&"
import script from "./SubWarning.vue?vue&type=script&lang=js&"
export * from "./SubWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports